import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22df4a82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute left-0 flex flex-col gap-y-10" }
const _hoisted_2 = {
  key: 0,
  class: "absolute bottom-0 left-0 right-0 flex items-end justify-between sm:gap-x-10"
}

import { ProductLabel, ProductLabelType } from '@/types/productServerApi';
import ProductSplashLabelNewArrival from '@/shared/product/splash/ui/ProductSplashLabelNewArrival.vue';
import ProductSplashLabelCustomize from '@/shared/product/splash/ui/ProductSplashLabelCustomize.vue';
import ProductSplashLabelProductSpot from '@/shared/product/splash/ui/ProductSplashLabelProductSpot.vue';
import ProductSplashLabelRecommended from '@/shared/product/splash/ui/ProductSplashLabelRecommended.vue';
import ProductSplashLabelSelected from '@/shared/product/splash/ui/ProductSplashLabelSelected.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSplashLabels',
  props: {
    labels: null,
    selected: { type: Boolean },
    recommended: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    labels: ProductLabel[],
    selected?: boolean,
    recommended?: boolean,
}




const newArrivalLabel = computed(() => props.labels?.find((label) => label.type === ProductLabelType.NewArrival));
const productSpotLabel = computed(() => props.labels?.find((label) => label.type === ProductLabelType.ProductSpot));
const customizeLabel = computed(() => props.labels?.find((label) => label.type === ProductLabelType.Customize));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["absolute inset-0 my-10", {'-ml-2': __props.selected}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.recommended && !__props.selected)
        ? (_openBlock(), _createBlock(ProductSplashLabelRecommended, _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), null, 16))
        : _createCommentVNode("", true),
      (__props.selected)
        ? (_openBlock(), _createBlock(ProductSplashLabelSelected, _normalizeProps(_mergeProps({ key: 1 }, _ctx.$attrs)), null, 16))
        : _createCommentVNode("", true),
      (_unref(newArrivalLabel))
        ? (_openBlock(), _createBlock(ProductSplashLabelNewArrival, {
            key: 2,
            label: _unref(newArrivalLabel)
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      (_unref(productSpotLabel))
        ? (_openBlock(), _createBlock(ProductSplashLabelProductSpot, {
            key: 3,
            label: _unref(productSpotLabel)
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(customizeLabel))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ProductSplashLabelCustomize, { label: _unref(customizeLabel) }, null, 8, ["label"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})